import { useState } from 'react';
import useAsyncQueue from './react/useAsyncQueue';
import usePreservedCallback from './react/usePreservedCallback';
import { useTunnel } from './tunnel/TunnelProvider';
import ToastPopup from '@/components/ToastPopup/ToastPopup.tsx';
import { ToastPopup as Interface } from '@/components/ToastPopup/types';
import { v4 as uuid } from 'uuid';

type PropsTypes = Interface.Input & {
  ms?: number;
};

export default function useToast() {
  const tunnel = useTunnel();

  return usePreservedCallback(
    ({ message, ms = 1500 }: PropsTypes): Promise<boolean> =>
      new Promise((resolve) =>
        tunnel(({ close }) => {
          setTimeout(() => {
            close();
            resolve(true);
          }, ms);

          return <ToastPopup message={message} />;
        }),
      ),
  );
}

export const useQueueToast = () => {
  const [id] = useState(uuid());
  const enqueue = useAsyncQueue();
  const toast = useToast();

  return (...params: Parameters<typeof toast>) =>
    enqueue(id, () => toast(...params));
};
